// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/chunk-" + {"42":"87728bfb07f74cb4","142":"5fb8e57df8759eb2","237":"bb3b1ec4d16861db","415":"cda29c7894a4285d"}[chunkId] + ".js";
};